/*
 * @author : Augusto Monteiro
 * @email  : augustomna2010@gmail.com
 * @augustomna2010 
 */


Monet.UI = Monet.UI || {};

Monet.UI.QuickFilter = (function () {


    /*
     * here is the object with all filters
     * @methods (render, getValue, type, attr, eq)
     * name is used on criteria
     * if are boolean filter dont need getValue
     */

    function QuickFilter () {

        this.rootEl = document.createElement("div");
        this.filterContainerEl = document.createElement("div");
        this.filtersConfig = [];
        this.filters = [];
        this.filtersInstances = {};
        this.actionListenner = null;
        this.booleanFilters = null;
        this.showOnly = true;
        this.showOnlyEl = null;

        this.filters["ROUTE_NOT_STARTED"] = {
            "type": "BOOLEAN",
            "attr": "route.status",
            "in": "NOT_STARTED",
            "icon": "gmfont icon-hand"
        };

        this.filters["ROUTE_STARTED"] = {
            "type": "BOOLEAN",
            "attr": "route.status",
            "in": "STARTED",
            "icon": "gmfont icon-route-started"
        };

        this.filters["ROUTE_DEPARTED_ORIGIN"] = {
            "type": "BOOLEAN",
            "attr": "route.status",
            "in": "DEPARTED_ORIGIN",
            "icon": "gmfont icon-up"
        };

        this.filters["ROUTE_ARRIVED_ORIGIN"] = {
            "type": "BOOLEAN",
            "attr": "route.status",
            "in": "ARRIVED_ORIGIN",
            "icon": "gmfont icon-down"
        };

        this.filters["INPUT"] = {
            "attr": "<INPUT>",
            "el": null,
            "matchMode": "ANYWHERE",
            "render": function (QuickFilter) {
                this.el = document.createElement("input");

                var timeout = null;

                this.el.addEventListener("keyup", function () {
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        QuickFilter.executeListeners();
                    }, 500);
                });
                return this.el;
            },
            "setValue": function (value) {
                this.el.value = value;
                return 0;
            },
            "getValue": function () {
                return this.el.value;
            }
        };

        this.setFiltersConfig = function (config) {
            this.filtersConfig = config;
        };

        this.setActionListener = function (cb) {
            this.actionListenner = cb;
        };

        this.checkAnotherFilterWithSameAttrIsEnabled = function (attr) {
            Object.keys(this.filtersInstances).forEach(function (instance) {
                var filter = this.filtersInstances[instance];
                if (filter.attr === attr && !filter.in) {
                    filter.setState(false);
                }
            }.bind(this));
        };

        this.executeListeners = function () {
            if (this.actionListenner) {
                this.actionListenner();
            }
        };

        this.createBooleanFilter = function (filterObject, filter) {

            this.filters[filter].el = null;
            this.filters[filter].setState = function (enabled) {
                if (enabled) {
                    this.active = true;
                    this.el.setAttribute("filter-enabled", "true");
                    this.el.className = this.el.className.replace("filterActived", "").trim();
                    this.el.className += " filterActived";
                } else {
                    this.active = false;
                    this.el.setAttribute("filter-enabled", "false");
                    this.el.className = this.el.className.replace("filterActived", "").trim();
                }
            };
            this.filters[filter].render = function (scope) {
                this.active = false;
                this.el = document.createElement("a");
                this.el.className = "quickFilterItem " + filterObject.icon;
                this.el.setAttribute("filter-type", filterObject.type);
                this.el.setAttribute("filter-attr", filterObject.attr);

                this.el.addEventListener("click", (function (filter) {
                    return function () {
                        if (this.getAttribute("filter-enabled") !== "true") {
                            scope.checkAnotherFilterWithSameAttrIsEnabled(filter.attr);
                            filter.setState(true);
                        } else {
                            filter.setState(false);
                        }
                        scope.executeListeners();
                        scope.checkShowOnly();
                    };
                }(this)));

                return this.el;
            };

            this.filters[filter].getValue = function () {
                return (this.el.getAttribute("filter-enabled") === "true") ? (filterObject.eq || filterObject.in) : null;
            };

            this.filtersInstances[filter] = this.filters[filter];
            return this.filtersInstances[filter];

        };

        this.createNonBooleanFilter = function (filterObject, filter) {
            this.filtersInstances[filter] = filterObject;
            return this.filtersInstances[filter];
        };

        this.checkFilterTypeAndCreate = function (filter) {
            var filterObject = this.filters[filter];
            if (filterObject.type && filterObject.type === "BOOLEAN") {
                this.createBooleanFilter(filterObject, filter);
            } else {
                this.createNonBooleanFilter(filterObject, filter);
            }
        };

        this.createFiltersInstance = function () {
            this.filtersConfig.forEach(function (filter) {
                this.checkFilterTypeAndCreate(filter);
            }.bind(this));
        };

        this.renderFilters = function () {
            Object.keys(this.filtersInstances).forEach(function (instance) {
                this.filterContainerEl.appendChild(this.filtersInstances[instance].render(this));
            }.bind(this));
        };

        this.checkShowOnly = function () {

            var booleanFiltersActived = this.booleanFilters.filter(function (filter) {
                return this.filtersInstances[filter].active === true;
            }, this);

            if (this.booleanFilters.length === booleanFiltersActived.length) {
                this.showOnlyEl.setAttribute("active", true);
            } else {
                this.showOnlyEl.setAttribute("active", false);
            }
        };

        this.showOnlyToogle = function () {
            var state = null;

            if (this.showOnlyEl.getAttribute("active") === "true") {
                state = false;
                this.showOnlyEl.setAttribute("active", false);
            } else {
                state = true;
                this.showOnlyEl.setAttribute("active", true);
            }

            this.booleanFilters.forEach(function (filter) {
                this.filtersInstances[filter].setState(state);
            }, this);

            this.executeListeners();
        }.bind(this);

        this.renderShowOnly = function () {

            if (this.showOnly) {
                var el             = document.createElement("a")
                    , filterSwitch = document.createElement("div")
                    , label        = document.createElement("div");

                el.className = "quickFilterItem quickFilterShowOnly";

                filterSwitch.className = "quickFilterSwitch";

                label.className = "quickFilterLabel";
                label.innerHTML = Monet.I18n.getResourcesByKey('routemonitor.filters.by') + ':';

                el.appendChild(filterSwitch);
                el.appendChild(label);

                el.addEventListener("click", this.showOnlyToogle);

                this.rootEl.appendChild(el);
                this.showOnlyEl = el;
            }
        };

        this.getCriteria = function () {
            var criteria    = [],
                criteriaIns = {};

            Object.keys(this.filtersInstances).forEach(function (instance) {
                var filter = this.filtersInstances[instance],
                    value  = filter.getValue();

                if (value) {
                    if (filter.in) {
                        criteriaIns[filter.attr] = criteriaIns[filter.attr] || [];
                        criteriaIns[filter.attr] = criteriaIns[filter.attr].concat(filter.in);
                    } else {
                        var _criteria = {
                            and: [{
                                attr: filter.attr,
                                eq: value
                            }]
                        };
                        if (filter.matchMode) {
                            _criteria.and[0].matchMode = filter.matchMode;
                        }
                        criteria.push(_criteria);
                    }
                }

            }.bind(this));

            Object.keys(criteriaIns).forEach(function (ins) {
                criteria.push({
                    and: [{
                        attr: ins,
                        "in": criteriaIns[ins]
                    }]
                });
            }.bind(this));

            return { criteriaChain: criteria };
        };

        this.calculateTotalBooleanFilters = function () {
            this.booleanFilters = Object.keys(this.filtersInstances).filter(function (filter) {
                return this.filtersInstances[filter].type === "BOOLEAN";
            }, this);
        };

        this.render = function () {
            this.renderShowOnly();
            this.createFiltersInstance();
            this.renderFilters();
            this.calculateTotalBooleanFilters();

            this.rootEl.className = "QuickFilter";

            this.rootEl.appendChild(this.filterContainerEl);

            return this.rootEl;
        };

    };

    return QuickFilter;

})();